import { jsx as i } from "react/jsx-runtime";
import m from "./index.es737.js";
import { getNumericFormat as g } from "./index.es732.js";
import { CellTextPrimitive as u } from "./index.es738.js";
import { CellAdditionalInfoWrapper as y } from "./index.es731.js";
const h = (e, n = 1, l = !1, o = !1, r) => {
  if (r && typeof r == "function")
    return r(e);
  const f = r ? "default" : l ? "percentage" : "number", t = e.toString();
  return g({
    value: t,
    type: f,
    shorten: o,
    maxDecimal: n,
    signIndicator: !1
  }) ?? t;
}, j = ({
  value: e,
  enableShortening: n = !1,
  decimalPrecision: l = 1,
  customFormatter: o,
  shouldShowTextWhenNoValue: r = !1,
  noValueText: s = "N/A",
  isPercent: f = !1,
  textAlign: t,
  additionalInfo: p,
  align: a = "right"
}) => {
  if (e == null && r)
    return /* @__PURE__ */ i("div", { className: m.numericCellRoot, children: s });
  let c = (e == null ? void 0 : e.toString()) || "";
  e != null && (c = h(
    e,
    l,
    f,
    n,
    o
  ));
  const d = t || a;
  return /* @__PURE__ */ i(
    "div",
    {
      className: m.numericCellRoot,
      style: { justifyContent: d === "right" ? "flex-end" : "flex-start" },
      children: /* @__PURE__ */ i(y, { ...p, children: /* @__PURE__ */ i(u, { children: c }) })
    }
  );
};
export {
  j as NumericCell
};
//# sourceMappingURL=index.es567.js.map
